import { scalarButton } from "./button/index.js";
import { scalarCallout } from "./callout/index.js";
import { scalarCard } from "./card/index.js";
import { scalarCodeBlock } from "./code-block/index.js";
import { scalarCodeGroup } from "./code-group/index.js";
import { scalarDetail } from "./detail/index.js";
import { scalarEmbed } from "./embed/index.js";
import { scalarFineprint } from "./fineprint/index.js";
import { scalarFlex } from "./flex/index.js";
import { scalarHeading, scalarPageTitle } from "./headings/index.js";
import { scalarIcon } from "./icon/index.js";
import { scalarImage } from "./image/index.js";
import { scalarMath } from "./math/index.js";
import { scalarPageLink } from "./page-link/index.js";
import { scalarPill } from "./pill/index.js";
import { scalarRow } from "./row/index.js";
import { scalarStep, scalarSteps } from "./step/index.js";
import { scalarTab, scalarTabs } from "./tabs/index.js";
export * from "./button/index.js";
export * from "./callout/index.js";
export * from "./card/index.js";
export * from "./code-block/index.js";
export * from "./code-group/index.js";
export * from "./detail/index.js";
export * from "./embed/index.js";
export * from "./fineprint/index.js";
export * from "./flex/index.js";
export * from "./headings/index.js";
export * from "./icon/index.js";
export * from "./image/index.js";
export * from "./math/index.js";
import { scalarMermaid } from "./mermaid/index.js";
export * from "./page-link/index.js";
export * from "./pill/index.js";
export * from "./row/index.js";
import { scalarScript } from "./script/index.js";
export * from "./step/index.js";
export * from "./tabs/index.js";
const customElements = {
  [scalarButton.name]: scalarButton,
  [scalarCallout.name]: scalarCallout,
  [scalarCard.name]: scalarCard,
  [scalarRow.name]: scalarRow,
  [scalarEmbed.name]: scalarEmbed,
  [scalarIcon.name]: scalarIcon,
  [scalarMath.name]: scalarMath,
  [scalarFlex.name]: scalarFlex,
  [scalarCodeBlock.name]: scalarCodeBlock,
  [scalarCodeGroup.name]: scalarCodeGroup,
  [scalarHeading.name]: scalarHeading,
  [scalarImage.name]: scalarImage,
  [scalarFineprint.name]: scalarFineprint,
  [scalarPageTitle.name]: scalarPageTitle,
  [scalarPill.name]: scalarPill,
  [scalarTab.name]: scalarTab,
  [scalarTabs.name]: scalarTabs,
  [scalarSteps.name]: scalarSteps,
  [scalarStep.name]: scalarStep,
  [scalarDetail.name]: scalarDetail,
  [scalarPageLink.name]: scalarPageLink
};
const getCustomElement = (tagName) => {
  return customElements[tagName];
};
export {
  customElements,
  getCustomElement,
  scalarMermaid,
  scalarScript
};
//# sourceMappingURL=index.js.map
